import { ApplicationConfig } from "@angular/core";
import {
  provideRouter,
  withHashLocation,
  withRouterConfig,
} from "@angular/router";
import { routes } from "./app.routes";
import { provideAnimations } from "@angular/platform-browser/animations";

import { Formio } from "@formio/js";
import premium from "@formio/premium";
import { environment } from "../environments/environment";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { authInterceptor } from "./core/interceptors/auth.interceptor";

Formio.license = environment.LICENSE;
Formio.use(premium);

const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get("token");

if (token) {
  localStorage.setItem("formioToken", token);
  Formio.setToken(token);
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      withHashLocation()
    ),
    provideAnimations(),
    provideHttpClient(
      withInterceptors([authInterceptor])
    )
  ],
};
